import React from 'react'
import { DialogContent } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import {
  DeleteDialog,
  DeleteDialogIconBox,
  DeleteDialogTitle,
  DeleteDialogBody,
  StyledDialogActions,
  DialogCancelButton,
  DialogConfirmButton,
} from './styled'

const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => {
  return (
    <DeleteDialog open={open} onClose={onClose} maxWidth='sm'>
      <DialogContent>
        <DeleteDialogIconBox>
          <DeleteOutlineIcon color='error' fontSize='large' />
        </DeleteDialogIconBox>
        <DeleteDialogTitle>Delete Rule</DeleteDialogTitle>
        <DeleteDialogBody>
          Are you sure you want to delete this rule? This action cannot be undone and the rule
          configuration will be permanently removed.
        </DeleteDialogBody>
      </DialogContent>
      <StyledDialogActions>
        <DialogCancelButton onClick={onClose}>Cancel</DialogCancelButton>
        <DialogConfirmButton onClick={onConfirm} variant='contained' color='error'>
          Delete Rule
        </DialogConfirmButton>
      </StyledDialogActions>
    </DeleteDialog>
  )
}

export default DeleteConfirmationDialog
